import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import EmailHistory from "./email-history";
import SMSHistory from "./sms-history";
import { TableLoader } from "../../../library/table-loader";
import EmptyTableView from "../../../universal/empty-table";
import { useDispatch, useSelector } from "react-redux";
import { SolidButton } from "../../../library/button";
import { Title } from "../../../library/title";
import {
  changeCampaignsModal,
  resetChannelEmails,
  resetChannelSms,
  retrieveChannelEmails,
  retrieveChannelSms,
} from "../../../../redux/actions/campaigns";
import { UpperRow } from "../../../library/upper-row";
import "./style.scss";
import { sendErrorNotification } from "../../../universal/notifications/notifications";
import SearchContentField from "../../../universal/search-content-field/search-content-field.component";

const Index = () => {
  const dispatch = useDispatch();
  const campaigns = useSelector(
    (state) => state && state.campaigns && state.campaigns
  );
  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const userLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );

  const loadError = useSelector(
    (state) => state.campaigns.fetchAllChannels.error
  );

  const sourceLoading = useSelector(
    (state) => state.campaigns.activeChannel.source?.loading
  );

  const activeChannel = useSelector((state) => state.campaigns.activeChannel);
  const [searchQuery, setSearchQuery] = useState("");

  const searchContent = (e) => {
    setSearchQuery(e.target.value);
  };

  const determineAddButtonDisplay = () => {
    if (!activeCompany) {
      return "add-file-button disabled";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "add-file-button disabled";
    }

    return "add-file-button";
  };

  const determineButtonState = () => {
    if (activeCompany && activeCompany.subscription) {
      return false;
    }
    return true;
  };

  const determineAddButtonClick = () => {
    if (activeCompany && activeCompany.subscription) {
      dispatch(changeCampaignsModal({ distributeModal: true }));
    } else {
      sendErrorNotification("Du må ha et aktivt abonnement.");
    }
  };

  const renderAddButton = () => {
    return (
      <SolidButton
        disabled={determineButtonState()}
        icon={<i class="fad fa-plus"></i>}
        title="Ny utsendelse"
        color="blue"
        onClick={() => determineAddButtonClick()}
        className={determineAddButtonDisplay()}
      />
    );
  };

  const renderHistoryTable = () => {
    if (activeChannel.username && !sourceLoading) {
      if (activeChannel.type === "email") {
        return <EmailHistory searchQuery={searchQuery} />;
      } else {
        return <SMSHistory searchQuery={searchQuery} />;
      }
    }
    return null;
  };

  const renderLoader = () => {
    if (!loadError) {
      if (!activeChannel.username || sourceLoading) {
        return <TableLoader />;
      } else {
        if (activeChannel.type === "email") {
          if (campaigns.fetchAllEmails.loading) {
            return <TableLoader />;
          }
        } else {
          if (campaigns.fetchAllSms.loading) {
            return <TableLoader />;
          }
        }
      }
    }
    return null;
  };

  const renderEmpty = () => {
    if (activeChannel.username) {
      if (activeChannel.type === "email") {
        if (
          !campaigns.fetchAllEmails.loading &&
          campaigns.content.length === 0
        ) {
          return (
            <EmptyTableView
              title="Ingen utsendelser tilgjengelig"
              description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny utsendelse ved å trykke på knappen øverst til høyre."
            />
          );
        }
      }
      if (!campaigns.fetchAllSms.loading && campaigns.content.length === 0) {
        return (
          <EmptyTableView
            title="Ingen utsendelser tilgjengelig"
            description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny utsendelse ved å trykke på knappen øverst til høyre."
          />
        );
      }
    }
    if (loadError) {
      return (
        <EmptyTableView
          title="Ingen utsendelser tilgjengelig"
          description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny utsendelse ved å trykke på knappen øverst til høyre."
        />
      );
    }
    return null;
  };

  useEffect(() => {
    if (!userLoading) {
      if (selectedCompany && activeChannel.id) {
        if (activeChannel.type === "email") {
          dispatch(resetChannelEmails());
          dispatch(
            retrieveChannelEmails({
              companyId: selectedCompany,
              channelId: activeChannel.id,
            })
          );
        } else {
          dispatch(resetChannelSms());
          dispatch(
            retrieveChannelSms({
              companyId: selectedCompany,
              channelId: activeChannel.id,
            })
          );
        }
      }
    }
  }, [activeChannel, selectedCompany]);

  return (
    <section className="dashboard-campaigns-bottom-row-section">
      <div className="inner-dashboard-campaigns-bottom-row-container">
        <UpperRow title="Historikk" buttons={[renderAddButton()]} />
        <SearchContentField
          searchQuery={searchQuery}
          handleSearch={searchContent}
        />
        {renderHistoryTable()}
        {renderLoader()}
        {renderEmpty()}
      </div>
    </section>
  );
};

export default Index;
